import { Honeybadger } from '@honeybadger-io/react'
import { collectHydrationForensics, isHydrationError, looksTampered } from './utils/hydrationForensics'

Honeybadger.configure({
    apiKey: process.env.NEXT_PUBLIC_HONEYBADGER_API_KEY,
    environment: process.env.NODE_ENV === 'production' ? (process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview' ? 'staging' : 'production') : 'development',
    revision: process.env.NEXT_PUBLIC_HONEYBADGER_REVISION || process.env.VERCEL_GIT_COMMIT_SHA || Date.now().toString(),
    projectRoot: 'webpack://_N_E/./',
    developmentEnvironments: ['dev', 'development', 'test'],
    reportData: process.env.NODE_ENV === 'production',
    // debug: true,
}).beforeNotify((notice) => {
    if (!notice) {
        return
    }
    if (notice.name === 'window.onunhandledrejection') return false;

    const ignoredMessages = [
        "Couldn't find Invoice",
        "ResizeObserver loop limit exceeded",
        "ResizeObserver loop completed with undelivered notifications.",
        "Failed to load chunk",
        "Loading chunk",
        "reading 'getBoundingClientRect'",
        "Minified React error #418",
        "Minified React error #423",
        // Browser extensions (crypto wallets, Grammarly, etc.) monkeypatch
        // appendChild and JSON.stringify DOM nodes, hitting React fibers. This
        // is thrown from injected code inside React's commit phase, so our
        // _next/ react-dom frames are in the stack and defeat the injected-
        // script heuristic below. Not our bug; drop by message.
        "Converting circular structure to JSON",
    ];
    /*
        A hydration error carries its own evidence now. React only gives us a minified code
        in production, so without this a #425 says a mismatch happened and nothing about
        what: three rounds of fixes have each removed a real cause and the reports continued.
        The snapshot taken before hydration says whether the page still matched what the
        server sent, and whether anything we do not ship had been at it first.

        A mismatch on a page that something else rewrote is not ours to fix and would drown
        the real ones, so it is dropped - but only on the evidence, never on the error code
        alone. A hydration error on an untouched page still reports, which is the case that
        would tell us we have broken something again.
    */
    if (isHydrationError(notice.message)) {
        const forensics = collectHydrationForensics();
        notice.context = { ...(notice.context || {}), hydration: forensics };
        if (looksTampered(forensics)) return false;
    }

    if (notice.message && ignoredMessages.some(msg => notice.message.includes(msg))) return false;
    if (['Error', 'window.onerror'].includes(notice.name) && ignoredMessages.includes(notice.message)) return false;

    // Ignore errors from injected scripts (browser extensions, bots, etc.)
    // These have no stack trace from our app code - just "global code" at line 1
    const backtrace = notice.backtrace || [];
    if (backtrace.length > 0) {
        const hasAppCode = backtrace.some(frame => {
            const file = frame.file || '';
            // Our app code comes from _next/ bundles or webpack
            return file.includes('/_next/') || file.includes('webpack');
        });
        // If no frames from our code, it's likely an injected script
        if (!hasAppCode) return false;
    }
})
Honeybadger.logger.debug('Honeybadger configured for browser')
